let defaultConfig = {
    cacheExpire: 60,
    search: {
        wait: 1200,
    },
};
export const behaviorGroup = 'group';
export const behaviorItem = 'resource';
export const ModuleManageSuffix = CITYHUB_MANAGE_SUFFIX;
export const formatRouteAppCode = (code) => code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '');
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
export const isNil = (a) => a == null;
export const isNull = (a) => a == null;
export const isNullOrUndefined = (...values) => {
    return values.every(value => {
      return value === null || value === undefined;
    });
};
export const isString = (a) => !!a && a.constructor === String;
export const isBoolean = (a) => typeof a === 'boolean';
export const isNumber = (a) => !!a && !isNaN(a) && !isNaN(parseFloat(a));
export const isInteger = (a) => !!a && typeof a === 'number' && Number(a) == a && Number(a) % 1 === 0; // tslint:disable-line triple-equals
export const isArray = (a) => !!a && a.constructor === Array;
export const isArrayKey = (key) => isInteger(key) && parseInt(key) >= 0;
export const isArrayOrObject = (a) => !!a && Object(a) === a;
export const isObject = (a) => !!a && Object.prototype.toString.call(a) === '[object Object]';
export const isScalar = (a) => !isObject(a);
export const isDate = (a) => !!a && a.constructor === Date;
export const isEvent = (a) => !!a && a.constructor === Event;
export const isPromise = (a) => !!a && a.constructor.name === Promise;
export const isUndefined = (a) => a === undefined;
export const isEmptyObject = (a) => !!a && Object.keys(a).length === 0;
export const exists = (a, allowEmptyString = false) => a != null && (allowEmptyString || a !== '');
export const isPrimitive = (a) => 'object' !== typeof a;
export const isEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};
export const isJson = (item) => {
    item = typeof item !== "string" ?
        JSON.stringify(item) :
        item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;

    // try {
    //     JSON.parse(str);
    // } catch (e) {
    //     return false;
    // }
    // return true;
};
export const isURL = (str) => {
    let res = !!str && str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
};
export const isAbsoluteURL = (str) => {
    let res = !!str && str.match(/^(?:[a-z]+:)?\/\//gi);
    return (res !== null)
};
export const isRelativeURL = (str) => {
    return !isAbsoluteURL(str);
};

export const encodeParams = (params, keys = null) => {
    if(!params) return params;

    let _params = params;
    if(keys) {
        if(!(params instanceof  URLSearchParams)) {
            if(isJson(params)) {
                Object.keys(params).forEach(function(key, index) {
                    if(isJson(params[key])) {
                        params[key] = JSON.stringify(params[key]);
                    }
                });
            }
            _params = new URLSearchParams(params);
        }

        // Função para remover nulls recursivamente
        const removeNulls = obj => {
            if (Array.isArray(obj)) {
                return obj.map(removeNulls).filter(item => item != null && (typeof item !== "object" || Object.keys(item).length > 0));
            } else if (obj !== null && typeof obj === "object") {
                const cleaned = {};
                Object.entries(obj).forEach(([key, value]) => {
                    const cleanedValue = removeNulls(value);
                    if (cleanedValue !== null && (typeof cleanedValue !== "object" || Object.keys(cleanedValue).length > 0)) {
                        cleaned[key] = cleanedValue;
                    }
                });
                return cleaned;
            } else {
                return obj;
            }
        };

        if(isString(keys)) {
            keys = [keys];
        }

        keys.forEach(key => {
            if (key && _params.has(key)) {
                let val = _params.get(key);
                if (val != null) {
                    try {
                        let parsed = isString(val) && isJson(val) ? JSON.parse(val) : val;
                        let cleaned = removeNulls(parsed);
                        _params.set(key, btoa(JSON.stringify(cleaned)));
                    } catch (e) {
                        _params.set(key, btoa(val));
                    }
                }
            }
        });
    }

    return Object.fromEntries(_params);
};

export const encodeUrlParams = (uri, keys = null) => {
    if (!uri) return uri;

    const isRelative = isRelativeURL(uri);
    const _forwardSlash = isRelative ? /^\/.*$/i.test(uri) : false;
    const _base = isRelative ? window.location.origin : null;
    const _url = new URL(uri, _base);
    const _pathname = _url.pathname;
    const _queryString = _url.searchParams;

    // Função para remover nulls recursivamente
    const removeNulls = obj => {
        if (Array.isArray(obj)) {
            return obj.map(removeNulls).filter(item => item != null && (typeof item !== "object" || Object.keys(item).length > 0));
        } else if (obj !== null && typeof obj === "object") {
            const cleaned = {};
            Object.entries(obj).forEach(([key, value]) => {
                const cleanedValue = removeNulls(value);
                if (cleanedValue !== null && (typeof cleanedValue !== "object" || Object.keys(cleanedValue).length > 0)) {
                    cleaned[key] = cleanedValue;
                }
            });
            return cleaned;
        } else {
            return obj;
        }
    };

    let _params = encodeParams(_queryString, keys);
    if(isJson(_params)){
        _params = (new URLSearchParams(_params)).toString();
    }

    // if (keys && _queryString.has(keys)) {
    //     let val = _queryString.get(keys);
    //     if (val != null) {
    //         try {
    //             let parsed = isString(val) && isJson(val) ? JSON.parse(val) : val;
    //             let cleaned = removeNulls(parsed);
    //             _queryString.set(keys, btoa(JSON.stringify(cleaned)));
    //         } catch (e) {
    //             _queryString.set(keys, btoa(val));
    //         }
    //     }
    //     _params = _queryString.toString();
    // } else {
    //     _params = btoa(_queryString.toString());
    // }

    return `${isRelative ? "" : _url.origin}${_forwardSlash ? _pathname : _pathname.replace(/^\/|\/$/g, "")}${_params ? "?" + _params : ""}`;
};

export const isBlob = (value, isReactNative) => {
    return isReactNative
      ? isObject(value) && !isUndefined(value.uri)
      : isObject(value) &&
          typeof value.size === 'number' &&
          typeof value.type === 'string' &&
          typeof value.slice === 'function';
};
export const isFile = (value, isReactNative) => {
    return (
      isBlob(value, isReactNative) &&
      typeof value.name === 'string' &&
      (isObject(value.lastModifiedDate) || typeof value.lastModified === 'number')
    );
};
export const delay = (fn, ms, context) => {
    let timer = 0
    return function(...args) {
      clearTimeout(timer)
      timer = setTimeout(fn.bind(context ?? this, ...args), ms || 0)
    }
};
// converting first letter to uppercase
export const capitalizeFirstLetter = (word) => {
    return word ? word
        .toLowerCase()
        .replace(/\w/, firstLetter => firstLetter.toUpperCase()) : word;
};
export const slugify = str =>
    str ? str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '') : str;
export const accessProperty = (obj, path) => {
    const arr = path ? path.split(".") : [];
    while(arr.length && obj && (obj = obj[arr.shift()]));
    return obj;
};

const _operations = {
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
    "*": (a, b) => a * b,
    "/": (a, b) => a / b,
    "%": (a, b) => a % b,
    "%": (a, b) => a % b,
    "==": (a, b) => a == b,
    "===": (a, b) => a === b,
    "!=": (a, b) => a != b,
    "!==": (a, b) => a !== b,
    ">": (a, b) => a > b,
    ">=": (a, b) => a >= b,
    "<": (a, b) => a < b,
    "<=": (a, b) => a <= b,
    "empty": (a, b) => a === null || a.trim() === "",
    "notEmpty": (a, b) => !(a === null || a.trim() === ""),
};
export const operations = (a, op, b) => _operations[op](a, b);
export const arrayDot = (object, currentPath = '', reference = {}) => {
    var dotPath = (isString(currentPath) && currentPath) || '';
    for(const key in object) {
        const value = object[key];
        const newKey = dotPath === "" ? key : dotPath + "." + key;
        if(isObject(value) || isArray(value)) {
            arrayDot(value, newKey, reference);
        } else {
            reference[newKey] = value;
        }
    }
    return reference;
};
export const uniqArray = (arrArg) => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) == pos);
export const toCamelCase = (str, capitalizeFirstLetter=false) => {
    let result = str ? str.toLowerCase().replace(/_([a-z])/g, (g) =>  g[1].toUpperCase()).replace(/_/,'') : null;
    if(result && capitalizeFirstLetter) {
        result = result.substring(0, 1).toUpperCase() + result.substring(1);
    }
    return result;
};
export const toSnakeCase = (e, separator = '_') => {
    let match = e.match(/([A-Z])/g);
    return match ?
        match.reduce(
            (str, c) => str.replace(new RegExp(c), separator + c.toLowerCase()),
            e
        )
        .substring((e.slice(0, 1).match(/([A-Z])/g)) ? 1 : 0)
        : e;
};
export const getPropertyValue = (obj, path, def=undefined) => {
    let val = path.split('.').reduce((acc, part) => {
        if(acc){
            let key = Object.keys(acc).find((key) => key.toLowerCase() === part.toLowerCase());
            return key ? acc[key] : undefined;
        }
        return undefined;
    }, obj);
    return val || def;
}
export const capitalizeFirstLetterWord = (e) => {
    return e ? e.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '';
};
export const containsHTML = (str) => {
    const htmlRegex = new RegExp("<(.|\\n)*?>", 'g');
    return htmlRegex.test(str);
};
export function strippedHTML(str) {
    let regex = /(<([^>]+)>)/ig;
    return str?.replace(regex, "") ?? str;
}
/**
 * This function is same as PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML
 * @return {string} Filtered text
 */
export const nl2br = (str, replaceMode = true, isXhtml = false) => {
    let breakTag = (isXhtml) ? '<br />' : '<br>';
    let replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
    return (str + '').replace(/([^>\\r\\n]?)(\\r\\n|\\n\\r|\\r|\\n)/g, replaceStr);
};
/**
 * This function inverses text from PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @return {string} Filtered text
 */
export const br2nl = (str, replaceMode = true) => {
    let replaceStr = (replaceMode) ? "\n" : '';
    // Includes <br>, <BR>, <br />, </br>
    return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
};
export const setAllObject = (obj, val) => Object.keys(obj).forEach(k => {
    if(obj[k] && typeof obj[k] == "object" ){
        setAllObject(obj[k], val);
    }else{
        obj[k] = val;
    }
});
export const nullify =  obj => setAllObject(obj, null);

function initCfg(value) {
    return isUndefined(value) ? false : value;
}
function matchKey(key, value) {
    key = key ? key.replace(/\[(\D+)\]/g, "$1").replace(/\]\[/g, ".").toLowerCase() : null;
    value = value ? value.toLowerCase() : null;
    return key && value ? (key == value || key.replace(/\[\d+\]/g, ".*.") == value) : false;
}
export const objectToFormData = (obj, cfg, fd, pre, exclude) => {
    if(pre && exclude){
        exclude = isArray(exclude)? exclude : [exclude];
        if(exclude.find(val => matchKey(pre, val))) {
            return fd;
        }
    }

    cfg = cfg || {
        /**
         * include array indices in FormData keys
         * defaults to true
         */
        indices: true,

        /**
         * treat null values like undefined values and ignore them
         * defaults to false
         */
        nullsAsUndefineds: false,

        /**
         * convert true or false to 1 or 0 respectively
         * defaults to false
         */
        booleansAsIntegers: false,

        /**
         * store arrays even if they're empty
         * defaults to false
         */
        allowEmptyArrays: true,

        /**
         * don't include array notation in FormData keys for any attributes except Files in arrays
         * defaults to false
         */
        noAttributesWithArrayNotation: false,

        /**
         * don't include array notation in FormData keys for Files in arrays
         * defaults to false
         */
        noFilesWithArrayNotation: false,

        /**
         * use dots instead of brackets for object notation in FormData keys
         * defaults to false
         */
        dotsForObjectNotation: false,
    };
    fd = fd || new FormData();

    cfg.indices = initCfg(cfg.indices);
    cfg.nullsAsUndefineds = initCfg(cfg.nullsAsUndefineds);
    cfg.booleansAsIntegers = initCfg(cfg.booleansAsIntegers);
    cfg.allowEmptyArrays = initCfg(cfg.allowEmptyArrays);
    cfg.noAttributesWithArrayNotation = initCfg(
        cfg.noAttributesWithArrayNotation,
    );
    cfg.noFilesWithArrayNotation = initCfg(cfg.noFilesWithArrayNotation);
    cfg.dotsForObjectNotation = initCfg(cfg.dotsForObjectNotation);

    const isReactNative = typeof fd.getParts === 'function';

    if (isUndefined(obj)) {
        return fd;
    } else if (isNil(obj)) {
        if (!cfg.nullsAsUndefineds) {
            fd.append(pre, '');
        }
    } else if (isBoolean(obj)) {
        if (cfg.booleansAsIntegers) {
            fd.append(pre, obj ? 1 : 0);
        } else {
            fd.append(pre, obj);
        }
    } else if (isArray(obj)) {
        if (obj.length) {
            obj.forEach((value, index) => {
                let key = pre + '[' + (cfg.indices ? index : '') + ']';

                if (
                    cfg.noAttributesWithArrayNotation ||
                    (cfg.noFilesWithArrayNotation && isFile(value, isReactNative))
                ) {
                    key = pre;
                }

                objectToFormData(value, cfg, fd, key, exclude);
            });
        } else if (cfg.allowEmptyArrays) {
            // fd.append(cfg.noAttributesWithArrayNotation ? pre : pre + '[]', '');
            fd.append(cfg.noAttributesWithArrayNotation ? pre : pre, '');
        }
    } else if (isDate(obj)) {
        fd.append(pre, obj.toISOString());
    } else if (isObject(obj) && !isBlob(obj, isReactNative)) {
        Object.keys(obj).forEach((prop) => {
            const value = obj[prop];

            if (isArray(value)) {
                while (prop.length > 2 && prop.lastIndexOf('[]') === prop.length - 2) {
                    prop = prop.substring(0, prop.length - 2);
                }
            }

            const key = pre
                ? cfg.dotsForObjectNotation
                    ? pre + '.' + prop
                    : pre + '[' + prop + ']'
                : prop;

            objectToFormData(value, cfg, fd, key, exclude);
        });
    } else {
        fd.append(pre, obj);
    }

    return fd;
};
export const buildFormData = (formData, data, root, exclude = []) => {
    if (data
        && typeof data === 'object'
        && !(data instanceof Array && data.length==0)
        && !(data instanceof Date)
        && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            if(exclude && !(!root && exclude.includes(key)) ) {
                buildFormData(formData, data[key], root ? `${root}[${key}]` : key, exclude);
            }
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(root, value);
    }
};
export const isFunction = (a) => !!a && {}.toString.call(a) === '[object Function]';
export const isDefined = (a) => !!a && typeof a !== 'undefined';
export const isEmpty = (a, allowEmptyString) => (a == null) || (!allowEmptyString ? a === '' : false) || (isArray(a) && a.length === 0) || isObject(a) && Object.keys(a).length === 0 && a.constructor === Object;
export const castArray = (...args) => {
    if (!args.length) return []
    const value = args[0]
    return Array.isArray(value) ? value : [value]
}
export const head = (array) => (array != null && array.length) ? array[0] : undefined;
export const last = (array) => { var length = array == null ? 0 : array.length; return length ? array[length - 1] : undefined; }
export const sortBy = (key) => { return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0); };
window.idSeed = 1000;
export const genId = (el, prefix=undefined) => (el = document.getElementById(el) || {}).id = el.id || (prefix === undefined ? "city-gen" : prefix) + (++window.idSeed);
export const uniqueId = () => {
    const dateString = Date.now().toString(36);
    const randomness = Math.random().toString(36).substr(2);
    return dateString + randomness;
};
export const formatString = (string, values = {}, prefixPlaceholder=':', suffixPlaceholder='') => {
    if (string === undefined || string === null) return '';
    string = String(string);
    prefixPlaceholder = prefixPlaceholder == '{' ? '\\{' : prefixPlaceholder;
    suffixPlaceholder = suffixPlaceholder == '}' ? '\\}' : suffixPlaceholder;
    for (const key in values) {
        const value = values[key];
        //const er = new RegExp(`${prefixPlaceholder}${key}${suffixPlaceholder}`, 'g');
        // exige que a seguir ao placeholder venha fim de string ou / ou ? ou &
        const suffixPart = suffixPlaceholder || `(?=$|/|\\?|&)`;
        const er = new RegExp(`${prefixPlaceholder}${key}${suffixPart}`, "g");
        string = string.replace(er, value ?? "");
    }

    return string.replace(/\/$/, "");
};
export const assertString = (input) => {
    const isString = typeof input === 'string' || input instanceof String;

    if (!isString) {
      let invalidType = typeof input;
      if (input === null) invalidType = 'null';
      else if (invalidType === 'object') invalidType = input.constructor.name;

      throw new TypeError(`Expected a string but received a ${invalidType}`);
    }
};
export const formatUrl = (url, values = {}, prefixPlaceholder=':', suffixPlaceholder='') => {
    return url ? formatString(url, dotNotation(values ?? {}), prefixPlaceholder, suffixPlaceholder).replace(/^\/+|\/+$/g, '') : null;
};

//////////////////////////////////////////////////////
//// Object property paths with wildcards and regexps
//////////////////////////////////////////////////////
const _regex = {
    dot: /^\./,
    prop: /[^[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    escape: /\\(\\)?/g,
};
const splitTokens = (input) => {
    const tokens = `${input}`.split('.');
    let results = [];
    let store = [];

    tokens.forEach(token => {
      if (/^.*\\$/.test(token)) {
        store.push(token.slice(0, token.length - 1));
      } else if (store.length > 0) {
        results = [...results, `${store.join('.')}.${token}`];
        store = [];
      } else {
        results.push(token);
      }
    });

    return results;
};
const matchToken = (key, token) => {
    if (token === '*') return true;

    return isInteger(token) ? key == token : key === token; // tslint:disable-line triple-equals
};
const hasToken = (path) => (
    path.indexOf('.') > -1 || path.indexOf('[') > -1
);
const tokenize = (str) => {
    const results = [];
    splitTokens(str).forEach(token => {
        token.replace(_regex.prop, (m, n, q, s) => {
            results.push(q ? s.replace(_regex.escape, '$1') : (n || m));
        });
    });

    return results;
};
const each = (obj, iteratee) => {
    if (!obj) return;

    if (isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        if (iteratee(obj[i], i, obj) === false) break;
      }
    } else if (isObject(obj)) {
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i++) {
        if (iteratee(obj[keys[i]], keys[i], obj) === false) break;
      }
    }
};
function _internalGet(data, path, value, options) {
    const opts = {
        ...{
            iterateObject: true,
            iterateArray: true,
        },
        ...(options || {}),
    };

    if (!path || !isString(path)) {
        return {
            exist: false,
            wildcard: false,
            values: [[value, data, []]],
        };
    }

    const key = '__get_item__';
    const tokens = tokenize(path);
    const length = tokens.length;
    const state = {
        index: 0,
        context: { [key]: [[data, data, []]] },
        wildcard: false,
    };

    tokens.forEach(token => {
        const next = [];

        each(state.context[key], ([item, _, p]) => {
            each(item, (v, k) => {
                if (!matchToken(k, token)) return;

                if (token !== '*') {
                    next.push([v, item, [...p, k]]);
                } else {
                    if (!opts.iterateObject && isObject(item)) return;
                    if (!opts.iterateArray && isArray(item)) return;
                    state.wildcard = true;
                    next.push([v, item, [...p, k]]);
                }
            });
        });

        if (next.length > 0) {
            state.context = { [key]: next };
            state.index++;
        }
    });

    if (state.index !== length) {
        return {
            exist: false,
            wildcard: state.wildcard,
            values: [[value, null, []]],
        };
    }

    return  {
        exist: true,
        wildcard: state.wildcard,
        values: state.context[key],
    };
};
const arrayRemove = (array, index) => (
    array.slice(0, index).concat(array.slice(index + 1))
);
const simpleRemove = (data, path) => {
    if (isArray(data) && isArrayKey(path)) {
        data = arrayRemove(data, parseInt(path, 10));
    } else {
        delete data[path];
    }

    return data;
};
/** Getter **/
export const resolvePath = (data, path, value, options) => {
    const { exist, wildcard, values } = _internalGet(data, path, value, options);

    if (!exist) return values[0][0];
    if (wildcard) return values.map(v => v[0]);
    return values[0][0] === undefined ? value : values[0][0];

    if (data === undefined)
        return
    if (!path || !isString(path))
        return

    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, '');           // strip a leading dot

    const key = '__get_item__';
    const tokens = tokenize(path);
    const length = tokens.length;
    const state = {
        index: 0,
        context: { [key]: [[data, data, []]] },
        wildcard: false,
    };

    tokens.forEach(token => {
        const next = [];

        each(state.context[key], ([item, _, p]) => {
            each(item, (v, k) => {
                if (!matchToken(k, token)) return;

                if (token !== '*') {
                    next.push([v, item, [...p, k]]);
                } else {
                    if (!opts.iterateObject && isObject(item)) return;
                    if (!opts.iterateArray && isArray(item)) return;
                    state.wildcard = true;
                    next.push([v, item, [...p, k]]);
                }
            });
        });

        if (next.length > 0) {
            state.context = { [key]: next };
            state.index++;
        }
    });

    let result = {};
    if (state.index !== length) {
        result = {
            exist: false,
            wildcard: state.wildcard,
            values: [[value, null, []]],
        };
    }else{
        result = {
            exist: true,
            wildcard: state.wildcard,
            values: state.context[key],
        };
    }

    if (!result.exist) return result.values[0][0];
    if (result.wildcard) return result.values.map(v => v[0]);
    return result.values[0][0] === undefined ? value : result.values[0][0];
    // let a = path.split('.');
    // for (let i = 0, n = a.length; i < n; ++i) {
    //     let k = a[i];
    //     if (data && k in data) {
    //         data = data[k];
    //     } else {
    //         return;
    //     }
    // }
    // return data;
};
/** Check value **/
export const hasPath = (data, path) => {
    if (!path || !isString(path)) return false;

    const key = '__has__item';
    const tokens = tokenize(path);
    let context = { [key]: [data] };
    let result = true;

    each(tokens, token => {
        const next = [];

        each(context[key], item => {
            each(item, (v, k) => {
                if (matchToken(k, token)) {
                    next.push(v);
                }
            });
        });

        if (next.length === 0) {
            result = false;
            return false;
        } else {
            context = { [key]: next };
          }

        return true;
    });

    return result;
};
/** Deleter **/
export const removePath = (data, path) => {
    if (!path || !isString(path)) {
        return data;
    }

    let _data = JSON.parse(JSON.stringify(data));

    if (!hasToken(path) && path !== '*') {
        return simpleRemove(_data, path);
    }

    const tokens = tokenize(path);

    if (tokens.indexOf('*') < 0) {
        const result = _data;

        each(tokens, (token, i) => {
            if (i === tokens.length - 1) {
                if (isArray(_data)) {
                    _data.splice(parseInt(token, 10), 1);
                } else {
                    delete _data[token];
                }
                return false;

            } else {
                _data = _data[token];
                return isObject(_data) || isArray(_data);
            }
        });

        return result;
    }

    const first = tokens.shift();
    const later = tokens.join('.');
    const isDataArray = isArray(_data);
    let count = 0;

    if (first === undefined) {
        return _data;
    }

    each(_data, (v, k) => {
        if (!matchToken(k, first)) {
            return;
        }

        if ((!isObject(v) && !isArray(v)) || !later) {
            if (!later) {
                if (isDataArray) {
                    _data = arrayRemove(_data, parseInt(k, 10) - count);
                    count += isDataArray ? 1 : 0;
                } else {
                    delete _data[k];
                }
            }
            return;
        }

        _data[k] = removePath(v, later);
    });

    return _data;
};
export const unsetPath = (object, path) => {
    if(object == null || !isObject(object)) return object;

    path = isArray(path) ? path : [path];

    path.forEach(p => {
        removePath(object, p);
    });
    return object;
}
//////////////////////////////////////////////////////
//////////////////////////////////////////////////////

let timeout = null;
export function debounce(func, wait=defaultConfig.search.wait, immediate=undefined) {
    return function () {
        clearTimeout(timeout);
        const context = this;
        const args = arguments;

        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
export const cleanDuplicatedQuestionMarks = (urlToNormalize) => {
    const urlParts = urlToNormalize.split("?");
    if (urlParts.length > 2) {
        let newUrlParts = urlParts.slice(1);
        return urlParts[0] + "?" + newUrlParts.join("&");
    }
    return urlToNormalize;
};
/**
 * Getting Scroll Position
 */
export function getScrollPosition(el) {
    const _el = document.querySelector(el);
    return {
        x: _el ? _el.scrollLeft : window.pageXOffset,
        y: _el ? _el.scrollTop : window.pageYOffset,
    };
};
/**
 * Setting Scroll Position
 */
export function setScrollPosition(position = { x: 0, y: 0 }, el, component) {
    const scrollTo = () => {
        const _el = el ? document.querySelector(el) : null;
        if (_el) {
            _el.scrollLeft = position.x;
            _el.scrollTop = position.y;
        } else {
            // window.scrollTo(position.x, position.y);
            $('html, body').animate({ scrollLeft: position.x, scrollTop: position.y }, 1000);
        }
    };
    if(component) {
        component.$nextTick(() => {
            scrollTo();
        });
    }else{
        scrollTo();
    }
};
/**
 * it removes some params from the query string
 * return the shrinked url
 */
export const getUrlWithoutParameters = (urlToFilter, skip = []) => {
    const urlparts = cleanDuplicatedQuestionMarks(urlToFilter).split('?');
    let paramsFiltered = "";
    if (urlparts.length >= 2 && urlparts[1]) {
        let _skip = (skip??[]).map(v => v.toLowerCase());
        const pars = urlparts[1].split(/[&;]/g).filter(p => !!p);
        pars.forEach((par, i) => {
            const param = par.split('=');
            if (_skip.indexOf(param[0].toLowerCase()) === -1) {
                let addAnd = i === (pars.length - 1) ? "" : "&";
                paramsFiltered += param.join("=") + addAnd;
            }
        });
    }
    return !!paramsFiltered ? urlparts[0] + "?" + paramsFiltered : urlparts[0];
};

export const filterUrlParams = (urlToFilter, params = []) => {
    if (isNil(urlToFilter) || urlToFilter === "") {
        return null;
    }
    return getUrlWithoutParameters(cleanDuplicatedQuestionMarks(urlToFilter), params);
};

export const getParsedUrl = (urlToParse, options, params = []) => {
    if (urlToParse) {
        const parsed = url.parse(filterUrlParams(urlToParse, params), true);
        let newPathname = null;
        if (endsWith(parsed.pathname, "wfs") || endsWith(parsed.pathname, "wms") || endsWith(parsed.pathname, "ows")) {
            newPathname = parsed.pathname.replace(/(wms|ows|wfs|wps)$/, "wps");
            return url.format(assign({}, parsed, { search: null, pathname: newPathname }, {
                query: assign({
                    service: "WPS",
                    ...options
                }, parsed.query)
            }));
        }
    }
    return null;
};
export const getLayerId = (layerObj) => {
    return layerObj && layerObj.id || layerObj.name + "__" + Math.random().toString(36).substring(2, 15);
};
export const getTocLayerId = (node, id = null) => 'tocLayer' + (id || node.id || ("__" + Math.random().toString(36).substring(2, 15)));
export const getDefaults = function() {
    return {...defaultConfig };
};
export const normalizeSourceUrl = function(sourceUrl) {
    if (sourceUrl && sourceUrl.indexOf('?') !== -1) {
        return sourceUrl.split('?')[0];
    }
    return sourceUrl;
};
export const getConfigProp = function(prop) {
    return defaultConfig[prop];
};
export const setConfigProp = function(prop, value) {
    defaultConfig[prop] = value;
};
export const removeConfigProp = function(prop) {
    delete defaultConfig[prop];
};
export const humanisePeriodDifference = function(diff) {
    // The string we're working with to create the representation
    var str = '';
    // Map lengths of `diff` to different time periods
    //var values = [[' anos', 365], [' meses', 30], [' dias', 1]];
    var values = [[' anos', 365], [' meses', 30]];

    // Iterate over the values...
    for (var i=0;i<values.length;i++) {
        var amount = Math.floor(diff / values[i][1]);

        // ... and find the largest time value that fits into the diff
        if (amount >= 1) {
            // and subtract from the diff
            diff -= amount * values[i][1];

            if (i==1 && diff == 30) {
                str += (amount+1) + values[i][0] + ' ';
                break;
            } else {
                // If we match, add to the string ('s' is for pluralization)
                str += amount + values[i][0] + ' ';
            }
        }
    }

    return str;
};
/**
 * Deep clean
 * The returned object will not have null values, empty strings or empty objects. Original object will not be modify.
 * @param obj
 */
export const deepClean = (obj) => {
    const isObject = (value) => Object.prototype.toString.call(value) === Object.prototype.toString.call({});
    const isEmptyObject = (value) => isObject(value) && Object.keys(value).length === 0;
    const isEmptyValue = (value) => value === null || value === '';
    const mustBeDeleted = (value) => isEmptyValue(value) || isEmptyObject(value);

    if (!isObject(obj)) throw new Error('Input parameter must be an object');

    const copy = JSON.parse(JSON.stringify(obj));
    const clean = (copy) => Object.keys(copy).reduce((acc, key) => {

        let value = copy[key];
        if (isObject(value) && !isEmptyObject(value)) value = clean(value);
        if (!mustBeDeleted(value)) acc[key] = value;
        return acc;
    }, {})

    return clean(obj);
};
/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}
function forEach(list, action = (value, index) => {}) {
    if (isNullOrUndefined(list)) {
        return;
    }

    for (let i = 0; i < list.length; i++) {
        action(list[i], i);
    }
}
function iterateObject(object, callback = (key, value) => {}) {
    if (isNullOrUndefined(object)) { return; }

    if (Array.isArray(object)) {
        forEach(object, (value, index) => callback(`${index}`, value));
    } else {
        forEach(Object.keys(object), key => callback(key, object[key]));
    }
}
export function customMergeDeep(dest, source, copyUndefined = true, objectsThatNeedCopy = [], iteration = 0) {
    if (!exists(source)) { return; }

    iterateObject(source, (key, sourceValue) => {
        let destValue = dest[key];

        if (destValue === sourceValue) { return; }

        const dontCopyOverSourceObject = iteration == 0 && destValue == null && sourceValue != null && objectsThatNeedCopy.indexOf(key) >= 0;
        if (dontCopyOverSourceObject) {
            // by putting an empty value into destValue first, it means we end up copying over values from
            // the source object, rather than just copying in the source object in it's entirety.
            destValue = {};
            dest[key] = destValue;
        }

        if (!isNullOrUndefined(destValue) && typeof destValue === 'object'
            && typeof sourceValue === 'object' && !Array.isArray(destValue)) {
            customMergeDeep(destValue, sourceValue, copyUndefined, objectsThatNeedCopy, iteration++);
        } else if (copyUndefined || sourceValue !== undefined) {
            dest[key] = sourceValue;
        }
    });
}
// const deepMerge = (target, source) => {
//     const isObject = (obj) => !!obj && obj.constructor === Object;

//     if (!isObject(target) || !isObject(source)) {
//         return source;
//     }

//     Object.keys(source).forEach(key => {
//         const targetValue = target[key];
//         const sourceValue = source[key];

//         if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
//             target[key] = targetValue.concat(sourceValue);
//         } else if (isObject(targetValue) && isObject(sourceValue)) {
//             target[key] = deepMerge(Object.assign({}, targetValue), sourceValue);
//         } else {
//             target[key] = sourceValue;
//         }
//     });

//     return target;
// }
/**
 * Deep equal two objects.
 * @param object1
 * @param object2
 */
export function equalDeep(object1, object2, exclude=[]) {
    const keys1 = isObject(object1) ? Object.keys(object1).filter(k => !exclude.includes(k)) : [];
    const keys2 = isObject(object2) ? Object.keys(object2).filter(k => !exclude.includes(k)) : [];
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if (
        areObjects && !equalDeep(val1, val2, exclude) ||
        !areObjects && val1 !== val2
      ) {
        return false;
      }
    }
    return true;
};

export function dotNotation(obj, tgt, path, separator = '.', useBrackets = true, keepArray = false, snakeCase = false, snakeCaseSeparator = '_') {
    tgt = tgt || {}
    path = path || []
    let isArray = Array.isArray(obj)

    Object.keys(obj).forEach(
      function (key) {
        let _key = snakeCase ? toSnakeCase(key, snakeCaseSeparator) : key;
        let index = isArray && useBrackets ? '[' + _key + ']' : _key
        if (
          isArrayOrObject(obj[key]) &&
          ((isObject(obj[key]) && !isEmptyObject(obj[key])) ||
            (Array.isArray(obj[key]) && !keepArray && obj[key].length !== 0))
        ) {
          if (isArray && useBrackets) {
            let previousKey = path[path.length - 1] || ''
            return dotNotation(
                obj[key],
                tgt,
                path.slice(0, -1).concat(previousKey + index),
                separator,
                useBrackets,
                keepArray,
                snakeCase,
                snakeCaseSeparator
            )
          } else {
            return dotNotation(
                obj[key],
                tgt,
                path.concat(index),
                separator,
                useBrackets,
                keepArray,
                snakeCase,
                snakeCaseSeparator
            )
          }
        } else {
          if (isArray && useBrackets) {
            tgt[path.join(separator).concat('[' + key + ']')] = obj[key]
          } else {
            tgt[path.concat(index).join(separator)] = obj[key]
          }
        }
      }.bind(this)
    )
    return tgt
};

/**
 * Flattening an array is a process of reducing the dimensionality of an array.
 * @param {Array} arr
 * @returns Array
 */
export function flatten(arr) {
    return arr.reduce(function (flat, toFlatten) {
      return flat.concat(isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
};

/**
 * Used to return a copy of the object that is composed of the picked object properties.
 * @param {*} obj
 * @param  {...any} keys
 * @returns
 */
export const pick = (obj, keys) =>
  Object.keys(obj)
    .filter(i => keys.includes(i))
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

export const findItemNested = (arr, fn, nestingKey) => (
    arr.reduce((a, item) => {
        if (a) return a;
        if (fn(item)) return item;
        if (nestingKey && item[nestingKey]) return findItemNested(item[nestingKey], fn, nestingKey)
    }, null)
);
/**
 * Utility to detect browser properties.
 * Code from leaflet-src.js
 */
export const getBrowserProperties = function() {

    let ie = 'ActiveXObject' in window;
    let ielt9 = ie && !document.addEventListener;
    let ie11 = ie && (window.location.hash === !!window.MSInputMethodContext && !!document.documentMode);

    // terrible browser detection to work around Safari / iOS / Android browser bugs
    let ua = navigator.userAgent.toLowerCase();
    let webkit = ua.indexOf('webkit') !== -1;
    let chrome = ua.indexOf('chrome') !== -1;
    let safari = ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
    let phantomjs = ua.indexOf('phantom') !== -1;
    let android = ua.indexOf('android') !== -1;
    let android23 = ua.search('android [23]') !== -1;
    let gecko = ua.indexOf('gecko') !== -1;

    let mobile = isMobile.any; // typeof window.orientation !== undefined + '';
    let msPointer = !window.PointerEvent && window.MSPointerEvent;
    let pointer = window.PointerEvent && window.navigator.pointerEnabled && window.navigator.maxTouchPoints ||
        msPointer;
    let retina = 'devicePixelRatio' in window && window.devicePixelRatio > 1 ||
        'matchMedia' in window && window.matchMedia('(min-resolution:144dpi)') &&
        window.matchMedia('(min-resolution:144dpi)').matches;

    let doc = document.documentElement;
    let ie3d = ie && 'transition' in doc.style;
    let webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    let gecko3d = 'MozPerspective' in doc.style;
    let opera3d = 'OTransition' in doc.style;
    let any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d || opera3d) && !phantomjs;

    let touch = !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window ||
        window.DocumentTouch && document instanceof window.DocumentTouch);

    return {
        ie: ie,
        ie11: ie11,
        ielt9: ielt9,
        webkit: webkit,
        gecko: gecko && !webkit && !window.opera && !ie,

        android: android,
        android23: android23,

        chrome: chrome,

        safari,

        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        opera3d: opera3d,
        any3d: any3d,

        mobile: mobile,
        mobileWebkit: mobile && webkit,
        mobileWebkit3d: mobile && webkit3d,
        mobileOpera: mobile && window.opera,

        touch: touch,
        msPointer: msPointer,
        pointer: pointer,

        retina: retina
    };
};

export const loadConfigurationModule  = function(store, name, all = false, filtered = [], config = {}) {
    function getNamespace(subtree, path) {
      if (path.length === 2) return subtree;

      const namespace = path.shift()
      subtree.modules[namespace] = {
        modules: {},
        namespaced: true,
        ...subtree.modules[namespace],
      }
      return getNamespace(subtree.modules[namespace], path)
    }

    const configModule = { routes: {}, state: {}, locales: {} };

    // let filterPattern = filtered.length ? `(${filtered.join('|')})` : '.*';
    const requireModule = require.context(
        // Search for files in the current directory.
        '../modules',
        // Search for files in subdirectories.
        true,
        // Include any .js files that are not this file or a unit test.
        // `/^\.\/${filterPattern}\/index\.js$/`,
        /^\.\/.*\/index\.js$/
    );

    // For every module...
    requireModule.keys().forEach((fileName) => {
        if (fileName.split(/\//).length>3)  return;

        const _module = requireModule(fileName);
        const moduleDefinition = _module['config'] ? _module['config'](store) : _module.default || _module;

        // Get the module path as an array.
        const modulePath = fileName
          // Remove the "./" from the beginning.
          .replace(/^\.\//, '')
          // Remove the file extension from the end.
          .replace(/\.\w+$/, '')
          // Split nested modules into an array path.
          .split(/\//)
          // camelCase all module namespaces and names.
          .map(toCamelCase);

        const moduleName = moduleDefinition?.state?.state?.data?.code;
        const moduleNameByFolder = modulePath.slice(0, -1).pop();
        if(all) {
            if (filtered && filtered.length>0 && !(filtered.includes(moduleName) || filtered.includes(moduleNameByFolder))) return;
        }else{
            if (moduleName !== name) return;
        }

        // Get the modules object for the current path.
        const { routes, state, locales } = getNamespace(configModule, modulePath)

        // Add the module to our modules object.
        if (moduleDefinition.state){
            state[moduleName] = {
                // By default, actions and mutations are still registered under the global namespace - this allows multiple modules to react to the same action/mutation type. Getters are also registered in the global namespace by default. However, this currently has no functional purpose (it's as is to avoid breaking changes). You must be careful not to define two getters with the same name in different, non-namespaced modules, resulting in an error.
                // If you want your modules to be more self-contained or reusable, you can mark it as namespaced with namespaced: true.
                // Modules are namespaced by default.
                namespaced: true,
                ...(typeof moduleDefinition.state === 'function' ? moduleDefinition.state(config) : moduleDefinition.state),
            }
        }

        if (moduleDefinition.routes){
            routes[moduleName] = {
                ...(typeof moduleDefinition.routes === 'function' ? moduleDefinition.routes(config) : moduleDefinition.routes),
            }
        }

        if (moduleDefinition.locales){
            locales[moduleName] = {
                ...(typeof moduleDefinition.locales === 'function' ? moduleDefinition.locales(config) : moduleDefinition.locales),
            }
        }

        return;
    });

    return {
        state: all ? configModule.state : (name in configModule.state ? configModule.state[name] : null),
        routes: all ? configModule.routes : (name in configModule.routes ? configModule.routes[name] : null),
        locales: all ? configModule.locales : (name in configModule.locales ? configModule.locales[name] : null),
    };
};

export const humanFileSize = function(bytes) {
    let thresh = 1024;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' Bytes';
    }
    let units = ['KB', 'MB', 'GB', 'TB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
};

export const fileSizeParser = function(input) {
    let validAmount  = function(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };

    let parsableUnit = function(u) {
        return u.match(/\D*/).pop() === u;
    };

    let incrementBases = {
      2: [
        [["B", "Bytes"], 1],
        [["Kb"], 128],
        [["k", "K", "kb", "KB", "KiB", "Ki", "ki"], 1024],
        [["Mb"], 131072],
        [["m", "M", "mb", "MB", "MiB", "Mi", "mi"], Math.pow(1024, 2)],
        [["Gb"], 1.342e+8],
        [["g", "G", "gb", "GB", "GiB", "Gi", "gi"], Math.pow(1024, 3)],
        [["Tb"], 1.374e+11],
        [["t", "T", "tb", "TB", "TiB", "Ti", "ti"], Math.pow(1024, 4)],
        [["Pb"], 1.407e+14],
        [["p", "P", "pb", "PB", "PiB", "Pi", "pi"], Math.pow(1024, 5)],
        [["Eb"], 1.441e+17],
        [["e", "E", "eb", "EB", "EiB", "Ei", "ei"], Math.pow(1024, 6)]
      ],
      10: [
        [["B", "Bytes"], 1],
        [["Kb"], 125],
        [["k", "K", "kb", "KB", "KiB", "Ki", "ki"], 1000],
        [["Mb"], 125000],
        [["m", "M", "mb", "MB", "MiB", "Mi", "mi"], 1.0e+6],
        [["Gb"], 1.25e+8],
        [["g", "G", "gb", "GB", "GiB", "Gi", "gi"], 1.0e+9],
        [["Tb"], 1.25e+11],
        [["t", "T", "tb", "TB", "TiB", "Ti", "ti"], 1.0e+12],
        [["Pb"], 1.25e+14],
        [["p", "P", "pb", "PB", "PiB", "Pi", "pi"], 1.0e+15],
        [["Eb"], 1.25e+17],
        [["e", "E", "eb", "EB", "EiB", "Ei", "ei"], 1.0e+18]
      ]
    };

    let options = arguments[1] || {};
    let base = parseInt(options.base || 2);

    let parsed = input.toString().match(/^([0-9\.,]*)(?:\s*)?(.*)$/);
    let amount = parsed[1].replace(',','.');
    let unit = parsed[2];

    let validUnit = function(sourceUnit) {
        return sourceUnit === unit;
    };

    if (!validAmount(amount) || !parsableUnit(unit)) {
        throw 'Can\'t interpret ' + (input || 'a blank string');
    }
    if (unit === '') return amount;

    let increments = incrementBases[base];
    for (let i = 0; i < increments.length; i++) {
        let _increment = increments[i];

        if (_increment[0].some(validUnit)) {
            return amount * _increment[1];
        }
    }

    throw unit + ' doesn\'t appear to be a valid unit';
};

export const convertHex2Rgba = function (color, opacity=.5) {
    if(!color){
        return '';
    }
    color = color.replace('#', '');
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);
    let result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    return result;
};

export const makeColor = (colorNum, colors) => {
    if (colors < 1) colors = 1;
    return colorNum * (360 / colors) % 360;
}

export const makeColors = (colorNum) => {
    let colors = [];
    for (let i = 0; i < colorNum; i++) {
        colors.push("hsl( " + makeColor(i, colorNum) + ", 100%, 75% )");
    }
    return colors;
}

/**
 * Escape a string for use in regular expressions.
 * @param {string} string
 */
export function escapeRegExp (string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
};

  /**
   * Given a string format (date) return a regex to match against.
   * @param {string} format
   */
export function regexForFormat (format) {
    let escaped = `^${escapeRegExp(format)}$`
    const formats = {
        MM: '(0[1-9]|1[012])',
        M: '([1-9]|1[012])',
        DD: '([012][0-9]|3[01])',
        D: '([012]?[0-9]|3[01])',
        YYYY: '\\d{4}',
        YY: '\\d{2}'
    }
    return new RegExp(Object.keys(formats).reduce((regex, format) => {
        return regex.replace(format, formats[format])
    }, escaped))
};

export function truncateDecimals (num, digits) {
    var numS = num.toString(),
        decPos = numS.indexOf('.'),
        substrLength = decPos == -1 ? numS.length : 1 + decPos + digits,
        trimmedResult = numS.substr(0, substrLength),
        finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;

    return parseFloat(finalResult);
};

export function setState(object, path, value) {
    const decomposedPath = path.split('.');
    const base = decomposedPath[0];

    if (base === undefined) {
        return object;
    }

    // assign an empty object in order to spread object
    if (!object.hasOwnProperty(base)) {
        object[base] = {};
    }
    // console.log({path});
    // Determine if there is still layers to traverse
    value = decomposedPath.length <= 1 ? value : setState(object[base], decomposedPath.slice(1).join('.'), value);

    return {
        ...object,
        [base]: isObject(value) ? (object.hasOwnProperty(base) ? {...object[base], ...value} : value) : value,
    }
};

export function parseLocaleNumber(stringNum, decimal=',', separator='.') {
    return stringNum ? parseFloat(stringNum.replaceAll(separator,"").replaceAll(decimal,".")) : stringNum;
}

const ConfigUtils = {
    getParsedUrl,
    getDefaults,
    cleanDuplicatedQuestionMarks,
    getUrlWithoutParameters,
    filterUrlParams,
    normalizeSourceUrl,
    getBrowserProperties,
    getConfigProp,
};

export default ConfigUtils;